import script from "./DestinyMatrixView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DestinyMatrixView.vue?vue&type=script&setup=true&lang=ts"

import "./DestinyMatrixView.vue?vue&type=style&index=0&id=7d68120c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d68120c"]])

export default __exports__